import { Component, Input, OnInit } from '@angular/core';
import { QuickLink, QuickLinkType } from '../../../../../models/quick-link';
import { Page } from '../../../../../models/page';
import { QuickLinkSignFormData } from '../../../../../models/quick-link-sign-form-data';
import { UserDataService } from '../../../../../services/user-data.service';
import { QuickLinkUtils } from '../../../../../utils/quick-link-utils';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { QuickLinkService } from '../../../../../services/quick-link.service';
import _ from 'lodash';
import { HomeworkService } from '../../../../../services/homework.service';
import { DigiFitDropdownComponent } from './digi-fit-dropdown/digi-fit-dropdown.component';
import { BookFeatureService } from '../../../../../services/book-feature.service';

@Component({
    selector: 'app-page-quick-link',
    templateUrl: './page-quick-link.component.html',
    styleUrls: ['./page-quick-link.component.scss'],
    standalone: true,
    imports: [
        DigiFitDropdownComponent
    ]
})
export class PageQuickLinkComponent implements OnInit {
    @Input() quickLink: QuickLink;
    @Input() page: Page;
    wasClicked: boolean;

    formData: QuickLinkSignFormData;
    isSignable = false;
    isDeactivated: boolean;
    tooltipPosition = 'bottom';

    isPageQuickLink = false;
    protected readonly QuickLinkType = QuickLinkType;

    constructor(
        public applicationStateService: ApplicationStateService,
        private quicklinkService: QuickLinkService,
        private homeworkService: HomeworkService,
        public bookFeatureService: BookFeatureService,
        private userDataService: UserDataService) {
    }

    ngOnInit(): void {
        this.isPageQuickLink = !this.quickLink.redirect && QuickLinkUtils.isQuicklinkLeadingToAPage(
            this.quickLink.link,
            this.applicationStateService.bookConfig.quickLinkPrefix
        );
        // this.applicationStateService.globalVars.disabledAssignments = ['gm1co1m1', 'gm1co1m3', 'gm1b26'];
        this.isDeactivated = _.includes(this.applicationStateService.globalVars.disabledAssignments,
            this.quickLink.slug);

        if (this.isDeactivated) {
            this.tooltipPosition = this.quickLink.position.y < 50 ? 'bottom' : 'top';
            setTimeout(() => {
                ($('[data-bs-toggle="tooltip"]') as any).tooltip();
            }, 500);
        }

        this.isSignable = this.quickLink.isSignable &&
            (
                (this.applicationStateService.bookConfig.fullESquirrelFeature && this.userDataService.isDigi4SchoolBook()) ||
                (this.applicationStateService.bookConfig.fullESquirrelFeatureBac && this.userDataService.hasBookAccessCode()) ||
                this.userDataService.isPlusFeatureAccessible()
            );
    }

    /**
     * On click event handler
     *
     * @param $event
     * @return {boolean}
     */
    onClick($event): boolean {
        this.wasClicked = true;

        if (this.quickLink.isHSM() && this.homeworkService.showHomeworkButton) {
            return this.homeworkService.openQuicklink(this.quickLink, this.page.id, $event);
        }

        return this.quicklinkService.openQuicklink(this.quickLink);
    }

    isDigiFitMenu(): boolean {
        return this.quickLink.isDigiFit();
    }
}
